// extracted by mini-css-extract-plugin
module.exports = {"imageCard":"SaverCategory_imageCard__mEerK","categoryIcon":"SaverCategory_categoryIcon__88LBH","imageContainer":"SaverCategory_imageContainer__L_OIK"};